import accessors from '../accessors';

const canBeHidden = (element) => Boolean(accessors.getHideConstraintForElement(element));

export default canBeHidden;
